import { AgGridReact } from 'ag-grid-react';
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Loader from '../../../../components/loader';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import toast from 'react-hot-toast';
import { showLocalDate } from '../../../../_common/functions';
import { useMaintenanceCalendarApi } from '../../../../store/api/hooks/maintenanceCalendarApiHook';
import OpenWOlistModal from './openWOlist.modal'; // Import modal

const PlannedMaintenance: React.FC = () => {
    const params: any = useParams();
    const [rowData, setrowData] = useState<any>(null);
    const maintenanceCalendarApi = useMaintenanceCalendarApi();
    const navigate = useNavigate();
    const myTheme = themeQuartz.withParams({
        headerBackgroundColor: `#F0F0F0`
    });
    const theme = useMemo<Theme | "legacy">(() => {
        return myTheme;
    }, []);

    const [selectedSchedulerID, setSelectedSchedulerID] = useState<number | null>(null);
    const modalRef = useRef<HTMLDialogElement>(null);



    const openModalWithScheduler = (schedulerID: number) => {
        setSelectedSchedulerID(schedulerID);
        modalRef.current?.showModal();
    };

    const columnDefs = [
        {
            headerName: 'Scheduler Number',
            field: 'schedulerCode',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 140,
            cellRenderer: (data: any) => (
                <p
                    className="text-primary cursor-pointer font-semibold truncate"
                    title={data.value || '--'}
                    onClick={() => openModalWithScheduler(data.data.schedulerID)}
                >
                    {data.value || '--'}
                </p>
            ),
        },
        {
            headerName: 'Frequency',
            field: 'frequencyName',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 120,
            cellRenderer: (data: any) => (
                <p className="truncate" title={data.value || '--'}>
                    {data.value || '--'}
                </p>
            ),
        },
        {
            headerName: 'Priority',
            field: 'priorityName',
            headerClass: 'bg-[#f0f0f0]',
            flex: 1,
            minWidth: 100,
            cellRenderer: (data: any) => (
                <p className="truncate" title={data.value || '--'}>
                    {data.value || '--'}
                </p>
            ),
        },
        {
            headerName: 'Start Date', field: 'planStartDate', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 140, cellStyle: { textAlign: 'center' }, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer truncate' title={data.value ? showLocalDate(data.value) : '--'}>
                        {data.value ? showLocalDate(data.value) : `--`}
                    </p>
                )
            },
            tooltipValueGetter: (params: any) => {
                return +params.data.statusID >= 4 ? (
                    //Actual start datetime
                    (params.data.originalPlanStartDate ? moment.utc(params.data.originalPlanStartDate).local().format(`MM/DD/YYYY hh:mm A`) : '')
                ) : (
                    params.data.planStartDate ? moment.utc(params.data.planStartDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`
                )
            }
        },
        {
            headerName: 'End Date', field: 'planEndDate', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 140,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer truncate' title={data.value ? showLocalDate(data.value) : '--'}>{data.value ? showLocalDate(data.value) : `--`}</p>
                )
            },
            tooltipValueGetter: (params: any) => {
                return +params.data.statusID >= 4 ? (
                    //Actual start datetime
                    (params.data.originalPlanEndDate ? moment.utc(params.data.originalPlanEndDate).local().format(`MM/DD/YYYY hh:mm A`) : ``)
                ) : (
                    params.data.planEndDate ? moment.utc(params.data.planEndDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`
                )
            }
        },
    ];

    const GetSchedulerList = (assetID: any = params.id) => {
        const payload: any = { assetID };
        setrowData(null);
        maintenanceCalendarApi.getSchedulerList(
            payload,
            (resp: any) => {
                setrowData(resp.schedulerList || []);
            },
            (error: any) => {
                console.log('error =>', error);
                toast.error(error);
            }
        );
    };

    useEffect(() => {
        if (params.id) {
            GetSchedulerList(params.id);
        }
    }, [params]);

    return (
        <div>
            <div className="flex items-center justify-between h-[60px]">
                <h4 className="font-semibold text-[0.938rem]">Planned Maintenance</h4>
            </div>
            <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[300px]'}`}>
                <AgGridReact
                    theme={theme}
                    columnDefs={columnDefs}
                    rowData={rowData || []}
                    pagination={false}
                    domLayout="normal"
                    ensureDomOrder={true}
                    suppressHorizontalScroll={false}
                    loadingOverlayComponent={Loader}
                    noRowsOverlayComponent={() => (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-500">
                                <div className="text-lg font-medium">No Data Found</div>
                            </div>
                        </div>
                    )}
                />
            </div>

            {/* Modal to show Open WO list */}
            <OpenWOlistModal _ref={modalRef} schedulerID={selectedSchedulerID} />
        </div>
    );
};

export default PlannedMaintenance;